import { TInvestmentBannerProps } from '../model';
import { Button } from '@shared/ui';
import { ArrowLeft } from 'iconsax-react';
import Link from 'next/link';

export function InvestmentMainBanner(props: TInvestmentBannerProps) {
  const content = (
    <div className='relative flex'>
      <div
        className='absolute inset-0 bg-cover bg-center'
        style={{ backgroundImage: `url(${props.backgroundImage})` }}
      />

      <div className='relative flex w-full gap-5 flex-col items-center justify-center px-4 py-9'>
        <div className='flex flex-col'>
          <div className='flex flex-col gap-2 justify-center items-center'>
            <div
              className='size-[85px] bg-cover bg-center flex-shrink-0'
              style={{ backgroundImage: `url(${props.image})` }}
            />
            <p className='text-sm font-bold'>{props.title}</p>
          </div>
        </div>

        <div>
          {' '}
          <p className='flex text-xs opacity-90 text-center h-[32px]'>{props.description}</p>
        </div>
        <div className='flex flex-1 flex-wrap items-center justify-center gap-[8px]'>
          {props.tags &&
            props.tags.map((tag, index) => (
              <span
                key={`${tag.title}-${index}`}
                className='flex items-center gap-1 rounded-[6px] bg-[#FFFFFF1A] px-3 py-1 text-[12px] font-semibold text-white'
              >
                {tag.title}
              </span>
            ))}
        </div>

        <div className='inline-block group'>
          <Button
            type='button'
            tabIndex={-1}
            className='bg-white text-[#323E54] h-[40px] mt-4 w-[200px] hover:bg-white
      transition-all duration-200 ease-out
      group-hover:-translate-y-[2px]'
          >
            {props.buttonText}
            <ArrowLeft
              size={16}
              className='mr-1 transition-transform duration-200 ease-out group-hover:-translate-x-1'
            />
          </Button>
        </div>
      </div>
    </div>
  );
  if (props.isExternal) {
    return (
      <a
        href={props.href}
        target='_blank'
        className='relative flex h-[380px] w-full overflow-hidden rounded-xl text-white mt-4'
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      href={props.href}
      className='relative flex h-[380px] w-full overflow-hidden rounded-xl text-white mt-4'
    >
      {content}
    </Link>
  );
}
